import React from 'react';

import FundUpdatePressMediaItem from 'buyside/components/presentation/Feed/FundUpdate/FundUpdatePressMediaItem/fundUpdatePressMediaItem';
import Link from 'buyside/components/presentation/Link/link';

import { employerProfileVanityUrl } from 'buyside/util/urlHelper';
import { ActivityFeedEmployerProfileUpdateFragment, Maybe } from 'interfaces/graphql-typings';

import styles from './fundUpdatePressMediaListStyles.scss';

const FundUpdatePressMediaList: React.FC<{
  list: ActivityFeedEmployerProfileUpdateFragment['pressMediaList'];
  vanityLink?: Maybe<string>;
}> = ({ list, vanityLink }) => {
  let listItems = list?.edges;
  let fundLink = null;

  if (listItems && listItems.length > 2 && vanityLink) {
    const moreText = `(and ${listItems.length - 2} more...)`;
    fundLink = <Link to={employerProfileVanityUrl(vanityLink)}>{moreText}</Link>;
    listItems = listItems.slice(0, 2);
  }

  return (
    <div className={styles.fundUpdatePressMediaList}>
      {listItems?.map((edge, idx) => {
        const fundUpdatePressMediaItem = edge?.node;

        return <FundUpdatePressMediaItem key={idx} item={fundUpdatePressMediaItem} />;
      })}
      {fundLink}
    </div>
  );
};

export default FundUpdatePressMediaList;
